<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid
      .column.is-widescreen-5.is-desktop-6
        .u-mb-mi
          AppImg(:srcset="[{ srcset: '{CDN_URL}/ventures/basb@2x.webp 2x, {CDN_URL}/ventures/basb.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/basb@2x.png 2x, {CDN_URL}/ventures/basb.png 1x', type: 'image/png' }]" ratio="3:2")
      .column.is-widescreen-5.is-desktop-6
        .content.u-mb-xs
          div(v-html="$t('content')")
        AppLink(to="https://www.behance.net/gallery/74557103/BASB-Brand-Identity-Design" :title="$t('cta')" class="button-link  " v-html="$t('cta')")
        .u-mb-xs
        AppLink(to="https://www.behance.net/gallery/78092841/BASB-UIUX-Design" :title="$t('cta2')" class="button-link  " v-html="$t('cta2')")


  .u-mb-md

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"BASB",
    "pageDesc":"BASB is a task management software that provides a highly advanced and easy to use software for businesses to make it easier for them to run projects and teams easily. ",
    "mantra":"BASB project |management software.",
    "content":"<p>The reason we started thinking about developing our project management system was an internal need. While there are many project management systems, they all lacked the social flavor. With complex admin panels and hard to navigate interface, managing projects became even a more complex task. </p><p>While working on BASB, we wanted to create a project management software that has few features and with no boring interface. The system was created around how users interact and manage their daily tasks so it could provide a more humanized experience.</p><p>While working on the brand concept, we created it around BABS, the smart alien that can manage your tasks. With its nerdy attitude and large glasses, it can easily help you through your tasks using his super AI powers.</p><p>BASB will be launched by late 2020, but you can check the brand identity and website design on Behance and leave us your comments.</p>",
    "cta":"Brand identity",
    "cta2":"UX/UI design"
  },
  "ar": {
    "pageTitle":"باسب",
    "pageDesc":"باسب هو برنامج لإدارة المهام يوفر برنامجًا متقدمًا وسهل الاستخدام من أجل الشركات لتسهيل تشغيل المشاريع والفرق بسهولة.",
    "mantra":"باسب برنامج |إدارة المشاريع.",
    "content":"<p>كانت هناك حاجة داخلية وهذا هو ما دفعنا إلى تطوير نظام إدارة المشاريع. في حين أن هناك العديد من برامج وأنظمة إدارة المشاريع إلا أنها جميعًا تفتقر إلى النكهة الاجتماعية. مع وجود لوحة الأدمن معقدة وكذلك صعوبة في التنقل في الواجهة ومن هنا أصبحت إدارة المشروعات معقدة. </p><p>أثناء العمل على باسب أردنا إنشاء برنامج لإدارة المشاريع يحتوي على مميزات قليلة بدون واجهة مملة أو معقدة. اعتمدنا أثناء إنشاء النظام على كيفية تفاعل المستخدمين وإدارة مهامهم اليومية بحيث يمكن أن يوفر تجربة أكثر إنسانية.</p><p>أما بالنسبة للعمل على تصميم الهوية التجارية، قمنا بإنشاء كائن فضائي حيث يمكنه إدارة مهامك، بفضل ذكائه والنظارات الكبيرة، يمكن أن يساعدك بسهولة في أداء مهامك بالاعتماد على قوى الذكاء الاصطناعي الفائقة.</p><p>سيتم إطلاق باسب بحلول أواخر عام 2020، ولكن يمكنك التحقق من هوية العلامة التجارية وتصميم الموقع على بيهانس وترك لنا تعليقاتك.</p>",
    "cta":"تصميم العلامة التجارية",
    "cta2":"تصميم واجهة المستخدم / تجربة المستخدم"
  }
}
</i18n>
